module.exports = __webpack_public_path__ + "assets/img/sailing-version-earth.f8006369.png";